<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em;">Julie Moss writing poetry since her childhood. In 2010, she won the editor’s choice award for a worldwide poetry competition. It was published in an anthology of the best entries. In 1999, her poetry made it to the semi-finals for another competition. It was published online.</p>
<br/><p style="text-indent:00em;">Julie loves using words as art, to describe the places she sees, humanity and her Christian faith. She hopes you enjoy this anthology about Australia.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?bf7f2956